<template>
  <div>
    <!-- 添加培训资料 -->
    <div title="批量选择课件" visible.sync="isShow" v-if="isShow" width="70%" @submit.native.prevent>
      <el-form ref="resourceForm" :model="dataForm" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="课件名称" prop="dataName" >
              <el-input
                v-model="dataForm.dataName"
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="行业类型" prop="professionalCategory">
              <dictionarySelect ref="dictionarySelect"  :parentCode="$const.dictionary.TRAINING_INDUSTRY" :filter="true" @submit="professionalCategorySubmitHandle" clearable></dictionarySelect>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-button type="primary" @click="search">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="batch_table">
        <batchBox title="选中课件" :props="batchBoxProps" @selection-change="batchBoxChange" ref="batchBox"></batchBox>
        <!-- 课件列表 -->
        <div v-loading="tableLoading" element-loading-text="拼命加载中" >
          <el-table :data="dataList" @selection-change="selectionChange" :row-key="getRowKeys" ref="multipleTable" v-if="isTableShow">
            <el-table-column type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column property="dataName" label="课件名称"></el-table-column>
            <el-table-column property="teacherName" label="教师名称"></el-table-column>
            <el-table-column width="200" label="专业类别"
                            :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <span v-if="scope.row.professionalCategoryName" v-html="scope.row.professionalCategoryName">
              </span>
                <span v-else>
                --
              </span>
              </template>
            </el-table-column>
            <el-table-column  >
              <template slot="header" slot-scope="scope">
                <span>来源</span>
                <el-tooltip class="item" effect="dark" content="  来源：
              商城：从商城加入课程；
              上传：企业自己上传课程；
              平台分配：由平台分发给企业的课程" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <!-- 0未下达 1进行中 2已下达 -->
                <span v-if="scope.row.isMallImport != 1 && scope.row.sourceId">平台分配</span>
                <span v-if="scope.row.isMallImport!=1 && !scope.row.sourceId">上传</span>
                <span v-if="scope.row.isMallImport == 1">商城</span>
              </template>
            </el-table-column>

          </el-table>
          <div class="common_btm_pagination">
            <el-pagination
              background
              @size-change="sizeChange"
              :current-page="page"
              @current-change="pageChange"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" style="text-align: center; margin: 30px 0" class="p10">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../api/new/training";
import batchBox from '@/pages/trainingManagement/component/batchBox.vue';
import dictionarySelect from  "@/components/common/dictionarySelect";
import $const from "@/common/constant";


export default {
  name: "resourcesDataSelector",
  components: {batchBox, dictionarySelect},

  data() {
    return {
      $const: $const,
      isShow: false,
      dataForm: {
        dataName:  undefined,
        professionalCategoryName: undefined
      },
      dataList: [],

      total: 0,
      pageSize: 10,
      page: 1,

      tableLoading: false,
      options: [],
      selectDataList: [],
      isTableShow: true,
      batchBoxProps: {
        value: 'id',      // ID字段名
        label: 'dataName',   // 显示名称
      }
    }
  },
  methods: {
    professionalCategorySubmitHandle(data) {
        if (data) {
          this.dataForm.professionalCategoryName  = data.pathTextName;
        } else  {
          this.dataForm.professionalCategoryName = undefined;
        }
    },
    tableReload(){
      this.dataList = JSON.parse(JSON.stringify(this.dataList));
    },
    search(){
        this.page = 1;
        this.getDataList();
    },
    //获取资料列表
    getDataList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        isAble: 0,
        ...this.dataForm,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      this.tableLoading  = true;
      // getDataList
//getPageResourcesList
      api.pageResourcesListRewrite(param).then(res => {
        let list = res.data.records;
        this.dataList = list;
        this.total = res.data.total;
        this.tableLoading  = false;
      });
    },
    pageChange(e) {
      this.page = e;
      this.getDataList();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.search();
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    selectionChange(e) {
      this.selectDataList = e;
      this.$refs.batchBox.setSelection(e);
    },
    batchBoxChange(rows){
      if (this.selectDataList){
        this.$refs.multipleTable.clearSelection();
      }
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
        this.tableReload();
      }
    },
    setSelection(rows){
      this.$nextTick().then(() => {
        this.$refs.multipleTable.clearSelection();
        if (rows) {
          rows.forEach(row => {
            if (row.trainingResourcesDataId) {
              row.id = row.trainingResourcesDataId;
            }
            this.$refs.multipleTable.toggleRowSelection(row);
          });
          this.tableReload();
        }
      });
    },
    show(){
      this.isShow = true;
    },
    getRowKeys(row){
      return row.id;
    },
    confirm() {
      if (this.selectDataList) {
        this.selectDataList.forEach(obj => {
          //说明：professionalCategoryCheckValue 为 选中行业的最终子节点，由于历史遗留 professionalCategory 其他使用次组件的进行绑定的
          obj.professionalCategory = obj.professionalCategoryCheckValue;
        })
      }
      this.$emit("confirm", this.selectDataList);
      this.isShow = false;
    }
  },
  mounted() {
    this.search();
  }
}
</script>

<style lang="scss" scoped>
.batch_table{
  padding: 0 15px;
}
.BatchBox{
  margin-top: 2px!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/component/resourcesDataSelector.vue